// Hardcode full URL to improve response time
export const CONFIG_ENDPOINT_ORIGIN = window.location.origin;
export const CONFIG_ENDPOINT_PATH = "/wp-json/dev-api/v1/data/";
export const CONFIG_ENDPOINT = `${CONFIG_ENDPOINT_ORIGIN}${CONFIG_ENDPOINT_PATH}`;

export const DEFAULT_SOUND_TRACKS_MAXIMUM = 20;

export const SCORE_MAXIMUM = 1;
export const SCORE_MINIMUM = 0;
export const SCORE_MEDIAN = (SCORE_MAXIMUM + SCORE_MINIMUM) / 2;

export const SAFE_STAR_POSITION_RANGES = [{ min: 5, max: 45 }, { min: 55, max: 95 }];

export const DIALOGUE_COMPONENT_POSITIONS = ["top-right", "top-left", "bottom-right", "bottom-left"];
export const CHARACTER_COMPONENT_POSITIONS = [...DIALOGUE_COMPONENT_POSITIONS];
export const ENZO_COMPONENT_POSITIONS = ["bottom-right", "bottom-left"];



// WEBPACK FOOTER //
// ./src/constants.js